<template>
  <div>
    <div class="ft-22-333">我的考试</div>
    <div class="se-flex se-m-t-20 se-m-b-20">
      <div
        :class="[
          'se-btn',
          'cp',
          'ft-16-333',
          'se-m-r-25',
          activeIndex == 0 ? 'active' : '',
        ]"
        @click="changeTab(0, '')"
      >
        全部
      </div>
      <div
        :class="[
          'se-btn',
          'cp',
          'ft-16-333',
          'se-m-r-25',
          activeIndex == 1 ? 'active' : '',
        ]"
        @click="changeTab(1, '1')"
      >
        已完成
      </div>
      <div
        :class="['se-btn', 'cp', 'ft-16-333', activeIndex == 2 ? 'active' : '']"
        @click="changeTab(2, '0')"
      >
        待开始
      </div>
    </div>
    <div class="se-list" v-loading="loading">
      <div
        class="se-item se-flex jcsb se-p-t-20 se-p-b-20 se-bor-b"
        v-for="(item, index) in frontEndPageChange"
        :key="index"
      >
        <div style="width: 100%">
          <div class="se-flex aic se-m-b-10 jcsb">
            <div class="ft-18-000 se-m-r-20 se-flex aic">
              <span v-if="item.examType == 1">【课程】</span>
              <span v-if="item.examType == 2">【培训计划】</span>
              <span class="title">{{ item.planOrCourseName }}</span>
            </div>
            <img
              v-if="item.examPassed"
              :src="
                require(`../../../assets/icons/studyStatus${
                  item.examPassed ? 2 : 1
                }.png`)
              "
              style="width: 62px; height: 29px"
            />
          </div>
          <div class="se-flex ft-14-666">
            <div class="se-p-l-10 se-m-r-50" v-if="item.examPassed">
              交卷时间: {{ item.endTime }}
            </div>
            <div class="se-p-l-10 se-m-r-50" v-else>
              题目量: {{ item.count }}
            </div>
            <div>
              分数: {{ item.examPassed ? item.score : item.sumScore }}分
            </div>
          </div>
        </div>
        <div
          class="se-start-test cp"
          v-if="!item.examPassed"
          @click="getExamList(item.planOrCourseId, item.examType, item.planId)"
        >
          开始考试
        </div>
      </div>
    </div>
    <div class="se-flex-h-c se-m-t-20">
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 开始考试对话框 -->
    <el-dialog
      class="se-dialog"
      destroy-on-close
      :visible.sync="testVisible"
      width="665px"
    >
      <start-test
        :type="type"
        @onClose="onClose"
        :examData="examData"
        :courseId="courseId"
        :planId="planId"
      ></start-test>
    </el-dialog>
  </div>
</template>

<script>
import startTest from "../../course-info/components/startTest.vue";

export default {
  components: {
    startTest,
  },

  data() {
    return {
      type: "course",
      examData: {},
      courseId: "",
      planId: "",
      activeIndex: 0,
      testVisible: false,
      status: "",
      examList: [],
      pageNum: 1,
      pageSize: 6,
      total: 0,
      loading: false,
    };
  },
  created() {
    this.getMyExamList();
  },

  computed: {
    // 计算属性对数据进行处理
    frontEndPageChange() {
      const start = (this.pageNum - 1) * this.pageSize;
      const end = this.pageNum * this.pageSize;
      return this.examList.slice(start, end);
    },
  },

  methods: {
    // 分页回调
    currentChange(val) {
      this.pageNum = val;
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    // close
    onClose() {
      this.pageNum = 1;
      this.testVisible = false;
      this.getMyExamList();
    },

    getExamList(courseId, type, planId) {
      let id = planId;
      if (id == null) id = "";
      this.planId = id;
      this.$http
        .get(
          type === 1
            ? `server/portal/getExam/${courseId}?planId=${id}`
            : `server/portal/personCenter/getPlanExam/${courseId}`
        )
        .then((res) => {
          this.courseId = courseId;
          this.examData = res.data;
          this.type = type === 1 ? "course" : "study";
          this.testVisible = true;
        });
    },

    changeTab(index, status) {
      this.examList = [];
      this.pageNum = 1;
      this.activeIndex = index;
      this.status = status;
      this.getMyExamList();
    },

    //我的考试
    getMyExamList() {
      this.loading = true;
      this.$http
        .get(
          `/server/portal/personCenter/listExam/${
            this.status ? this.status : ""
          }`,
          {}
        )
        .then((res) => {
          this.examList = res.rows;
          this.total = res.total;
        });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.se-btn {
  width: 128px;
  height: 35px;
  border-radius: 16px;
  line-height: 35px;
  text-align: center;
  font-size: 16px;
  background-color: #f6f7f9;
}

.active {
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.09);
  color: #f41539;
  background-color: #fff;
}

.se-start-test {
  width: 124px;
  height: 47px;
  line-height: 47px;
  text-align: center;
  background-color: #e44352;
  border-radius: 5px;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
}

/deep/ .se-dialog .el-dialog__header {
  padding: 0;
}

/deep/ .se-dialog .el-dialog__body {
  padding: 0;
}

/deep/ .se-dialog .el-dialog {
  border-radius: 11px 11px 0 0;
}

.title {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>
